import { AIRPORT_TITLES } from '../types/GridTypes';
import {
  ContinentColumns,
  DestCityColumns,
  DestCountryColumns,
} from '../views/Columns';

export const aggregationChanged = (
  eValue: string,
  setReportTitle: any,
  setAggregatedClientFlights: any,
  setAggregatedCompetitorsFlights: any,
  setColums: any,
  setData: any,
  setCheckedList: any,
  setSelectedColumns: any,
  clientFlights: any,
  competitorsFlights: any,
  FlightColumns: any,
  AirportColumns: any,
  DestCityColumns: any,
  DestCountryColumns: any,
  defaultCheckedList: any,
  SetPlacement: any,
  relevantCompetitorsFlights: any,
  relevantClientFlights: any,
) => {
  SetPlacement(eValue);
  if (eValue === 'flight') {
    flightAggHandler(
      setReportTitle,
      setAggregatedClientFlights,
      setAggregatedCompetitorsFlights,
      setColums,
      setData,
      setCheckedList,
      setSelectedColumns,
      clientFlights,
      competitorsFlights,
      FlightColumns,
      defaultCheckedList,
    );
  }
  if (eValue === 'airport') {
    airportAggHandler(
      setReportTitle,
      setAggregatedClientFlights,
      setAggregatedCompetitorsFlights,
      setColums,
      setData,
      setCheckedList,
      setSelectedColumns,
      clientFlights,
      competitorsFlights,
      AirportColumns,
      relevantCompetitorsFlights,
      relevantClientFlights,
      defaultCheckedList,
    );
  }
  if (eValue === 'destinationCity') {
    destCityAggHandler(
      setReportTitle,
      setAggregatedClientFlights,
      setAggregatedCompetitorsFlights,
      setColums,
      setData,
      setCheckedList,
      setSelectedColumns,
      clientFlights,
      competitorsFlights,
      DestCityColumns,
      relevantCompetitorsFlights,
      relevantClientFlights,
      defaultCheckedList,
    );
  }
  if (eValue === 'destinationCountry') {
    destCountryHandler(
      setReportTitle,
      setAggregatedClientFlights,
      setAggregatedCompetitorsFlights,
      setColums,
      setData,
      setCheckedList,
      setSelectedColumns,
      clientFlights,
      competitorsFlights,
      DestCountryColumns,
      relevantCompetitorsFlights,
      relevantClientFlights,
      defaultCheckedList,
    );
  }
  if (eValue === 'continent') {
    setReportTitle('Competitive snapshot by continent');
    setColums(ContinentColumns);
  }
};
export const flightAggHandler = (
  setReportTitle: any,
  setAggregatedClientFlights: any,
  setAggregatedCompetitorsFlights: any,
  setColums: any,
  setData: any,
  setCheckedList: any,
  setSelectedColumns: any,
  clientFlights: any,
  competitorsFlights: any,
  FlightColumns: any,
  defaultCheckedList: any,
) => {
  setReportTitle('Competitive snapshot by flight');
  setAggregatedClientFlights(clientFlights);
  setAggregatedCompetitorsFlights(competitorsFlights);
  setColums(FlightColumns);
  setData(clientFlights);
  setCheckedList(defaultCheckedList(FlightColumns));
  setSelectedColumns(
    FlightColumns.map((item: any) => {
      if (!item.hidden) {
        return item.key as string;
      } else return '-1';
    }).filter((item: any) => item !== '-1'),
  );
};

export const airportAggHandler = (
  setReportTitle: any,
  setAggregatedClientFlights: any,
  setAggregatedCompetitorsFlights: any,
  setColums: any,
  setData: any,
  setCheckedList: any,
  setSelectedColumns: any,
  clientFlights: any,
  competitorsFlights: any,
  AirportColumns: any,
  relevantCompetitorsFlights: any[],
  relevantClientFlights: any[],
  defaultCheckedList: any,
) => {
  setReportTitle('Competitive snapshot by airport');
  const aggClient: any = {};
  const aggCompetitors: any = {};
  for (const flight of clientFlights) {
    if (!aggClient[flight[AIRPORT_TITLES.DESTINATION_AIRPORT]]) {
      aggClient[flight[AIRPORT_TITLES.DESTINATION_AIRPORT]] = { ...flight };
      aggClient[flight[AIRPORT_TITLES.DESTINATION_AIRPORT]][
        AIRPORT_TITLES.FLIGHTS
      ] = 1;
      aggClient[flight[AIRPORT_TITLES.DESTINATION_AIRPORT]][
        AIRPORT_TITLES.MY_PRICE
      ] = parseFloat(flight[AIRPORT_TITLES.MY_PRICE]);
    } else {
      const aggregated = aggClient[flight[AIRPORT_TITLES.DESTINATION_AIRPORT]];
      aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[AIRPORT_TITLES.FLIGHTS] +=
        1;
      if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
        aggregated[AIRPORT_TITLES.MY_PRICE] =
          parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
          parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
      } else {
        aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
          flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
        );
      }
    }
  }

  for (const flight of competitorsFlights) {
    const keyName = `${flight[AIRPORT_TITLES.DESTINATION_AIRPORT]}_${flight[AIRPORT_TITLES.COMPETITOR]}`;
    if (!aggCompetitors[keyName]) {
      aggCompetitors[keyName] = { ...flight };
      aggCompetitors[keyName][AIRPORT_TITLES.FLIGHTS] = 1;
      aggCompetitors[keyName][AIRPORT_TITLES.MY_PRICE] = parseFloat(
        flight[AIRPORT_TITLES.MY_PRICE],
      );
    } else {
      const aggregated = aggCompetitors[keyName];
      aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[AIRPORT_TITLES.FLIGHTS] +=
        1;
      if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
        aggregated[AIRPORT_TITLES.MY_PRICE] =
          parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
          parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
      } else {
        aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
          flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
        );
      }
    }
  }

  relevantCompetitorsFlights = [];
  relevantClientFlights = [];
  for (const key in aggClient) {
    aggClient[key][AIRPORT_TITLES.MY_PRICE] =
      `${Math.floor(aggClient[key][AIRPORT_TITLES.MY_PRICE] / aggClient[key][AIRPORT_TITLES.FLIGHTS])}`;
    relevantClientFlights.push(aggClient[key]);
  }
  for (const key in aggCompetitors) {
    aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] =
      `$${Math.floor(aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] / aggCompetitors[key][AIRPORT_TITLES.FLIGHTS])}`;
    relevantCompetitorsFlights.push(aggCompetitors[key]);
  }
  setAggregatedClientFlights(relevantClientFlights);
  setAggregatedCompetitorsFlights(relevantCompetitorsFlights);
  setColums(AirportColumns);
  setData(relevantClientFlights);
  setCheckedList(defaultCheckedList(AirportColumns));
  setSelectedColumns(
    AirportColumns.map((item: any) => {
      if (!item.hidden) {
        return item.key as string;
      } else return '-1';
    }).filter((item: any) => item !== '-1'),
  );
};

export const destCityAggHandler = (
  setReportTitle: any,
  setAggregatedClientFlights: any,
  setAggregatedCompetitorsFlights: any,
  setColums: any,
  setData: any,
  setCheckedList: any,
  setSelectedColumns: any,
  clientFlights: any,
  competitorsFlights: any,
  AirportColumns: any,
  relevantCompetitorsFlights: any[],
  relevantClientFlights: any[],
  defaultCheckedList: any,
) => {
  {
    setReportTitle('Competitive snapshot by destination city');
    const aggClient: any = {};
    const aggCompetitors: any = {};
    for (const flight of clientFlights) {
      if (!aggClient[flight[AIRPORT_TITLES.DESTINATION_CITY]]) {
        aggClient[flight[AIRPORT_TITLES.DESTINATION_CITY]] = { ...flight };
        aggClient[flight[AIRPORT_TITLES.DESTINATION_CITY]][
          AIRPORT_TITLES.FLIGHTS
        ] = 1;
        aggClient[flight[AIRPORT_TITLES.DESTINATION_CITY]][
          AIRPORT_TITLES.MY_PRICE
        ] = parseFloat(flight[AIRPORT_TITLES.MY_PRICE]);
      } else {
        const aggregated = aggClient[flight[AIRPORT_TITLES.DESTINATION_CITY]];
        aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[
          AIRPORT_TITLES.FLIGHTS
        ] += 1;
        if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
          aggregated[AIRPORT_TITLES.MY_PRICE] =
            parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
            parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
        } else {
          aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
            flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
          );
        }
      }
    }

    for (const flight of competitorsFlights) {
      const keyName = `${flight[AIRPORT_TITLES.DESTINATION_CITY]}_${flight[AIRPORT_TITLES.COMPETITOR]}`;
      if (!aggCompetitors[keyName]) {
        aggCompetitors[keyName] = { ...flight };
        aggCompetitors[keyName][AIRPORT_TITLES.FLIGHTS] = 1;
        aggCompetitors[keyName][AIRPORT_TITLES.MY_PRICE] = parseFloat(
          flight[AIRPORT_TITLES.MY_PRICE],
        );
      } else {
        const aggregated = aggCompetitors[keyName];
        aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[
          AIRPORT_TITLES.FLIGHTS
        ] += 1;
        if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
          aggregated[AIRPORT_TITLES.MY_PRICE] =
            parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
            parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
        } else {
          aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
            flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
          );
        }
      }
    }

    relevantCompetitorsFlights = [];
    relevantClientFlights = [];
    for (const key in aggClient) {
      aggClient[key][AIRPORT_TITLES.MY_PRICE] =
        `${Math.floor(aggClient[key][AIRPORT_TITLES.MY_PRICE] / aggClient[key][AIRPORT_TITLES.FLIGHTS])}`;
      relevantClientFlights.push(aggClient[key]);
    }
    for (const key in aggCompetitors) {
      aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] =
        `$${Math.floor(aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] / aggCompetitors[key][AIRPORT_TITLES.FLIGHTS])}`;
      relevantCompetitorsFlights.push(aggCompetitors[key]);
    }

    setAggregatedClientFlights(relevantClientFlights);
    setAggregatedCompetitorsFlights(relevantCompetitorsFlights);
    setColums(DestCityColumns);
    setData(relevantClientFlights);
    setCheckedList(defaultCheckedList(DestCityColumns));
    setSelectedColumns(
      DestCityColumns.map((item) => {
        if (!item.hidden) {
          return item.key as string;
        } else return '-1';
      }).filter((item) => item !== '-1'),
    );
  }
};

export const destCountryHandler = (
  setReportTitle: any,
  setAggregatedClientFlights: any,
  setAggregatedCompetitorsFlights: any,
  setColums: any,
  setData: any,
  setCheckedList: any,
  setSelectedColumns: any,
  clientFlights: any,
  competitorsFlights: any,
  AirportColumns: any,
  relevantCompetitorsFlights: any[],
  relevantClientFlights: any[],
  defaultCheckedList: any,
) => {
  setReportTitle('Competitive snapshot by destination country');
  const aggClient: any = {};
  const aggCompetitors: any = {};
  for (const flight of clientFlights) {
    if (!aggClient[flight[AIRPORT_TITLES.DESTINATION_COUNTRY]]) {
      aggClient[flight[AIRPORT_TITLES.DESTINATION_COUNTRY]] = { ...flight };
      aggClient[flight[AIRPORT_TITLES.DESTINATION_COUNTRY]][
        AIRPORT_TITLES.FLIGHTS
      ] = 1;
      aggClient[flight[AIRPORT_TITLES.DESTINATION_COUNTRY]][
        AIRPORT_TITLES.MY_PRICE
      ] = parseFloat(flight[AIRPORT_TITLES.MY_PRICE]);
    } else {
      const aggregated = aggClient[flight[AIRPORT_TITLES.DESTINATION_COUNTRY]];
      aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[AIRPORT_TITLES.FLIGHTS] +=
        1;
      if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
        aggregated[AIRPORT_TITLES.MY_PRICE] =
          parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
          parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
      } else {
        aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
          flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
        );
      }
    }
  }

  for (const flight of competitorsFlights) {
    const keyName = `${flight[AIRPORT_TITLES.DESTINATION_COUNTRY]}_${flight[AIRPORT_TITLES.COMPETITOR]}`;
    if (!aggCompetitors[keyName]) {
      aggCompetitors[keyName] = { ...flight };
      aggCompetitors[keyName][AIRPORT_TITLES.FLIGHTS] = 1;
      aggCompetitors[keyName][AIRPORT_TITLES.MY_PRICE] = parseFloat(
        flight[AIRPORT_TITLES.MY_PRICE],
      );
    } else {
      const aggregated = aggCompetitors[keyName];
      aggregated[AIRPORT_TITLES.FLIGHTS] = aggregated[AIRPORT_TITLES.FLIGHTS] +=
        1;
      if (typeof aggregated[AIRPORT_TITLES.MY_PRICE] === 'string') {
        aggregated[AIRPORT_TITLES.MY_PRICE] =
          parseFloat(aggregated[AIRPORT_TITLES.MY_PRICE].replace('$', '')) +
          parseFloat(flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''));
      } else {
        aggregated[AIRPORT_TITLES.MY_PRICE] += parseFloat(
          flight[AIRPORT_TITLES.MY_PRICE].replace('$', ''),
        );
      }
    }
  }

  relevantCompetitorsFlights = [];
  relevantClientFlights = [];
  for (const key in aggClient) {
    aggClient[key][AIRPORT_TITLES.MY_PRICE] =
      `${Math.floor(aggClient[key][AIRPORT_TITLES.MY_PRICE] / aggClient[key][AIRPORT_TITLES.FLIGHTS])}`;
    relevantClientFlights.push(aggClient[key]);
  }
  for (const key in aggCompetitors) {
    aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] =
      `$${Math.floor(aggCompetitors[key][AIRPORT_TITLES.MY_PRICE] / aggCompetitors[key][AIRPORT_TITLES.FLIGHTS])}`;
    relevantCompetitorsFlights.push(aggCompetitors[key]);
  }

  setAggregatedClientFlights(relevantClientFlights);
  setAggregatedCompetitorsFlights(relevantCompetitorsFlights);
  setColums(DestCountryColumns);
  setData(relevantClientFlights);
  setCheckedList(defaultCheckedList(DestCountryColumns));
  setSelectedColumns(
    DestCountryColumns.map((item) => {
      if (!item.hidden) {
        return item.key as string;
      } else return '-1';
    }).filter((item) => item !== '-1'),
  );
};
